/**
 * @description: 注册全局方法以及组件
 */
import dayjs from "dayjs";
import BatchQueryInput from "@/components/BatchQueryInput";
import CardList from "@/components/CardList";
import FixedText from "@/components/FixedText";
import HeadFilter from "@/components/HeadFilter";
import HeadMultipleFilter from "@/components/HeadMultipleFilter";
import NumberInput from "@/components/NumberInput";
import StatusTag from "@/components/StatusTag";
import XbdDialog from "@/components/XbdDialog";
import XbdDrawer from "@/components/XbdDrawer";
import XbdFilter from "@/components/XbdFilter";
import XbdTable from "@/components/XbdTable";
import XbdTabs from "@/components/XbdTabs";
import XbdTree from "@/components/XbdTree";
import UploadImgCode from "@/components/UploadImgCode";
import store from "@/store";
import { splicingThumbnail, setThousandths, hasPermission, addOssHostToFileUrl, emptyTextConversion } from "@/utils";

export default {
	install(Vue) {
		/**
		 * @description: 获取缩略图地址
		 */
		Vue.prototype.$splicingThumbnail = splicingThumbnail;

		/**
		 * @description: 将正常数字转换为带千分位的数字
		 */
		Vue.prototype.$setThousandths = setThousandths;
		/**
		 * @description: 判断是否有权限
		 */
		Vue.prototype.$hasPermission = hasPermission;
		/**
		 * @description: 日期格式化
		 */
		Vue.prototype.$dayjs = dayjs;
		/**
		 * @description: 当前币种符号
		 */
		Object.defineProperty(Vue.prototype, "$currentCurrencySymbol", {
			get() {
				return store.getters["currencySymbol"];
			}
		});
		/**
		 * @description: 将文件地址添加OSS host
		 */
		Vue.prototype.$addOssHostToFileUrl = addOssHostToFileUrl;
		/**
		 * @description: 空值转换
		 */
		Vue.prototype.$emptyTextConversion = emptyTextConversion;

		// 注册全局组件
		Vue.component("BatchQueryInput", BatchQueryInput);
		Vue.component("CardList", CardList);
		Vue.component("FixedText", FixedText);
		Vue.component("HeadFilter", HeadFilter);
		Vue.component("HeadMultipleFilter", HeadMultipleFilter);
		Vue.component("NumberInput", NumberInput);
		Vue.component("XbdTable", XbdTable);
		Vue.component("XbdDrawer", XbdDrawer);
		Vue.component("XbdDialog", XbdDialog);
		Vue.component("XbdTabs", XbdTabs);
		Vue.component("XbdFilter", XbdFilter);
		Vue.component("StatusTag", StatusTag);
		Vue.component("XbdTree", XbdTree);
		Vue.component("UploadImgCode", UploadImgCode);
	}
};
